<template>
  <div class="modal fade close-generate-token-modal" id="ViewGenerateTokenModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Gerar novo token empresarial</h1>
                  <button type="button" class="btn-close close-generate-token-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <form v-on:submit="generateToken()">
                <div class="modal-body">
                  <p>Tem certeza que precisa alterar o token empresarial ?</p>
                  <p>Para que os uploads continuem, será necessário usar o novo token nas requisições enviadas !<br>
                  A configuração do lado do servidor de forma errada pode causar a parada dos backups das gravações, quer realmente continuar ?</p>

                  <div class="mt-40 mb-mb-15 mb-md-20">
                    <label for="overviewPassword" class="form-label fw-medium"
                      >Digite sua senha para confirmar alteração</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="passwordGenerateToken"
                      required
                    />
                  <div id="errorGenerateToken" class="form-text red bold" style="display: none">
                    Erro, por favor verifique a senha!.
                  </div>
                </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" id="buttonSubmitGenerateToken" class="btn btn-success">Gerar novo token</button>
                    <button type="button" class="btn btn-danger close-generate-token-modal" data-bs-dismiss="modal">Fechar</button>
                </div>
            </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "ViewRecordingModal",
  data () {
    return {
      loadingAudioPlayer: false,
      errorMessage: ""
    }
  },
  computed:{
    ...mapGetters([
        'getCurrentRecording',
        'getCurrentUrlRecording',
        'getRecordingShowModalState'
    ])
  },
  methods: {
    ...mapActions([
      "setNewToken"
    ]),
    closeModalToken(){
      const modal = document.getElementById("ViewGenerateTokenModal");
      const backdrop = document.getElementsByClassName("modal-backdrop");
      const body = document.getElementsByTagName("body");
      
      if(modal){
        modal.classList.remove("show");
      }

      if(backdrop[0]){
        backdrop[0].classList.remove("show");
      }

      if(body[0]){
        body[0].style.overflow = "scroll";
      }
    },
    async generateToken(){
      event.preventDefault();
      const elementPassword = document.getElementById("passwordGenerateToken");
      if(!elementPassword || elementPassword.value == "" || elementPassword.value.length < 8 ){
        document.getElementById("errorGenerateToken").style.display = "block";
        elementPassword.value = "";
        return;
      }

      document.getElementById("buttonSubmitGenerateToken").innerHTML = "Carregando...";
      document.getElementById("buttonSubmitGenerateToken").disabled = true;
      const setNewToken = this.setNewToken;
      // const closeModalToken = this.closeModalToken;

        await api.axios.put('/api/generate/token/'+this.$route.params.id, {password: elementPassword.value}).catch(function(error){
          if(error.response.data != undefined){
            elementPassword.value = "";
            document.getElementById("errorGenerateToken").style.display = "block";
            document.getElementById("buttonSubmitGenerateToken").disabled = false;
            document.getElementById("buttonSubmitGenerateToken").innerHTML = "Gerar novo token";
          }
        }).then(function(response){
          if(response != undefined && response.status == 200){
            elementPassword.value = "";
            setNewToken(response.data.message);
            document.getElementById("buttonSubmitGenerateToken").disabled = true;
            document.getElementById("buttonSubmitGenerateToken").innerHTML = "Recarregando informações...";
            location.reload();
            // closeModalToken();
          }
        });
      
    }
  }
};
</script>